const METERS_PER_MILE = 1609.344;
const METERS_PER_KILOMETER = 1000;

const formatDistanceLabel = (countryCode, meters) => {
  let distanceLabel = "";

  if (countryCode && meters) {
    const convertDistance = (metersPerUnit) =>
      parseFloat(meters) / metersPerUnit;

    let convertedDistance = null;
    let unitType = "";

    if (countryCode === "US" || countryCode === "GB") {
      convertedDistance = convertDistance(METERS_PER_MILE);
      unitType = "mi";
    } else {
      convertedDistance = convertDistance(METERS_PER_KILOMETER);
      unitType = "km";
    }

    // This ensures NaN value for convertedDistance is not returned (i.e., avoids "NaNkm").
    if (convertedDistance) {
      distanceLabel = `${convertedDistance.toFixed(1)}${unitType}`;
    }
  }

  return distanceLabel;
};

export default formatDistanceLabel;
